export default "__VITE_ASSET__BOBTz6TK__"